import { useContext, useRef } from "react";
import { CompanyContext } from "@/components/CompanyList/CompanyContext";
import * as constants from "@/config/constants";
import { getIsNotUserFiltered } from "@/selectors";
import { useSelector } from "react-redux";
import { Transition } from "react-transition-group";

import { GiftBoxIcon } from "../../../client/assets/icons/common/GiftBoxIcon";
import { useExperiment } from "../../../hooks/useExperiment";
import { BaseBenefitsList } from "../../BaseComponents/BaseBenefitsList";
import { BaseCompanyLogo } from "../../BaseComponents/BaseCompanyLogo";
import { BaseCoupon } from "../../BaseComponents/BaseCoupon";
import { BaseFeaturedCompanyHeader } from "../../BaseComponents/BaseFeaturedCompanyHeader";
import BaseGridRatingHorizontal from "../../BaseComponents/BaseGridRatingHorizontal";
import BaseLinkWrapper from "../../BaseComponents/BaseLinkWrapper";
import BaseProductDescription from "../../BaseComponents/BaseProductDescription";
import BaseReviewLink from "../../BaseComponents/BaseReviewLink";
import BaseServiceFlag from "../../BaseComponents/BaseServiceFlag";
import { BaseSocialProof } from "../../BaseComponents/BaseSocialProof";
import { BaseVisitLink } from "../../BaseComponents/BaseVisitLink";
import { getStyles } from "./styles";

export const GridLayoutBeta = () => {
	const variant = useExperiment("prod-coffee-clubs-social-proof-icon-color");
	const { company, companyIndex, isFeaturedCompany } =
		useContext(CompanyContext);
	const { isNotUserFiltered } = useSelector(getIsNotUserFiltered);
	const styles = getStyles({
		isFeatured: isFeaturedCompany,
		companyIndex,
		variant,
	});
	const nodeRef = useRef(null);

	return (
		<Transition
			nodeRef={nodeRef}
			in
			appear={!isNotUserFiltered}
			timeout={constants.FILTERING_TRANSITION_DURATION}
			unmountOnExit
		>
			<div className={styles.layoutWrapper}>
				<BaseLinkWrapper>
					<BaseFeaturedCompanyHeader {...styles.featuredCompanyHeader} />
				</BaseLinkWrapper>
				<BaseLinkWrapper>
					<BaseCoupon {...styles.coupon} icon={<GiftBoxIcon />} />
				</BaseLinkWrapper>
				<div className={styles.rootGrid}>
					{/* Column 1 */}
					<div className={styles.col1}>
						<BaseLinkWrapper>
							<BaseServiceFlag classNames={styles.serviceFlag} />
							<div className={styles.logoWrapper}>
								<BaseCompanyLogo classNames={styles.companyLogo} />
							</div>
						</BaseLinkWrapper>
					</div>
					{/* Column 2 */}
					<div className={styles.col2}>
						<BaseLinkWrapper>
							<div>
								<BaseProductDescription
									className={styles.productDescription.text}
								/>
							</div>
							<div>
								<BaseGridRatingHorizontal classNames={styles.rating} />
							</div>
							<div>
								<BaseBenefitsList {...styles.benefitsList} />
							</div>
						</BaseLinkWrapper>
					</div>
					{/* Colum 3 */}
					<div className={styles.col3}>
						<BaseLinkWrapper>
							{companyIndex === 0 ? (
								<div className={styles.socialProofSection}>
									<BaseSocialProof {...styles.socialProof} />
								</div>
							) : null}
							<div>
								<BaseVisitLink {...styles.visitLink}>
									{`Visit ${company.fields.companyName}`}
								</BaseVisitLink>
							</div>
						</BaseLinkWrapper>
						<BaseReviewLink
							classNames={styles.reviewLink}
							linkText={"Read Review"}
						/>
					</div>
				</div>
			</div>
		</Transition>
	);
};
